import { createContext } from "react";
import { contextAsyncFunctionInit, contextFunctionInit } from "sprint-common-web";

import { getDefaultOrderRequestListingConfig, OrderRequestListingConfig } from "../config/OrderRequestListingConfig";
import { OrderRequestListingFilters } from "../hooks/useOrderRequestListingFilters";
import { OrderRequestListingItem } from "../OrderRequestListingItem";

interface IOrderRequestListingContext {
    items: OrderRequestListingItem[];
    selectedItems: OrderRequestListingItem[];
    totalItems: number;
    isLoading: boolean;
    listingConfig: OrderRequestListingConfig;
    pinnedItems: string[];
    saveListingConfig(config: OrderRequestListingConfig): void;
    setSelectedItems(selectedItems: OrderRequestListingItem[]): void;
    markAsChanged(itemId: string): void;
    reloadData(filters: OrderRequestListingFilters): Promise<void>;
    updateOrderRequest(
        orderRequest: Partial<OrderRequestListingItem> & Required<Pick<OrderRequestListingItem, "id">>
    ): void;
    togglePinnedOrderRequest(orderId: string): void;
}

export const OrderRequestListingContext = createContext<IOrderRequestListingContext>({
    items: [],
    selectedItems: [],
    pinnedItems: [],
    totalItems: 0,
    isLoading: true,
    listingConfig: getDefaultOrderRequestListingConfig(),
    saveListingConfig: contextFunctionInit,
    setSelectedItems: contextFunctionInit,
    markAsChanged: contextFunctionInit,
    reloadData: contextAsyncFunctionInit,
    updateOrderRequest: contextFunctionInit,
    togglePinnedOrderRequest: contextFunctionInit
});
